import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [{
	name: 'Forms',
	url: '/forms',
	icon: 'dashboard',
}];

export default class Data_Backup_Waiver extends Framework.Components.View {

	render() {
		let {match, baseUrl} = this.props

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Data Backup Waiver",
				url: `/forms/data_backup_waiver`,
				icon: 'book',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Objects.MandatoryDataBackupWaiver
					id={match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
				/>
			</div>
		);
	}
}

